"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
const utils_1 = require("../utils");
exports.default = new class ColumnComponent extends component_1.default {
    defaultOptions = { color: "red", bold: true };
    get() {
        const stack = (0, utils_1.getStack)()[3];
        return (stack.getColumnNumber() ?? stack.getEnclosingColumnNumber() ?? "??").toString();
    }
    ;
};
